import ABI from "./WebCash.json";

const ADDRESS = "0xb0914CE7AE24CAF808928B5B3Fea80a34160e130";
export { ABI, ADDRESS };
